import { IQuestionModel } from '@care-portals/api-interfaces';
import { IMAGE_TYPES } from '../../constants';

const questionsModels: IQuestionModel[] = [
  {
    label: 'Upload a Government ID showing your date of birth.',
    field: 'govIdUs',
    type: 'file_upload',
    questionImage: 'https://cdn.buttercms.com/pTC8iTmSdipV7CTZG9xV',
    accepts: IMAGE_TYPES,
    answer: [
      {
        resourceId: 'govIdUs',
        buttonLabel: 'Photo of ID'
      }
    ]
  }
];

export default questionsModels;
